import { default as ImgColorscape } from './img-colorscape';
ImgColorscape();
export { ImgColorscape };
